import React, { Component } from 'react';
import {connect} from 'react-redux';
import __ from 'lodash';
import {cekCookies} from '../../../../actions';
import axios from 'axios';
import { CONFIG } from '../../../../config';
import Navbar from '../../navbar/Navbar';
import Sidebar from '../../sidebar/Sidebar';
import { Row, Col } from 'react-bootstrap';
import LoaderModal from '../../../modal/LoaderModal';
import accountManagement from '../../../../apis/accountManagement';

import Loader from '../../../Loader';
import DdKelas from './master/DdKelas';
import DdMapel from './master/DdMapel';
import DdKategori from './master/DdKategori';


class MigrasiMapel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            cariSoal: false,
            loading: false,
            kelas : [],
            mapel : [],
            kategori : [],
            soal : [],
            idKelas : null,
            idMapel : null,
            idKategori : null,
            idSoal : null,
            namaUploadHistori : null,
            namaKelas : null,
            namaMapel : null,
            namaKategori : null,
        }
        this.fetchKelas = this.fetchKelas.bind(this);
    }

    async componentDidMount() {
        document.title = "Migrasi BankSoal";
        this.setState({
            isFetching: true
        });
        await this.props.cekCookies();

        if(!__.isEmpty(this.props.account)) {
            this.fetchKelas();
        }
        
        window.$("#sidebar").mCustomScrollbar({
            theme: "minimal"
        });

        window.$('#sidebarCollapse').on('click', function () {
            window.$('#sidebar, #content').toggleClass('active');
            window.$('.collapse.in').toggleClass('in');
            window.$('a[aria-expanded=true]').attr('aria-expanded', 'false');
        });

        this.setState({
            isFetching: false
        });
    }

    fetchKelas = async () => {
        const responseFetchKelas = await accountManagement.get(CONFIG.MIGRASI_V1_KELAS)
        .catch(function(error) {
            console.log('kelas error '+error)
        });

        console.log(responseFetchKelas)
        if(responseFetchKelas.request.readyState === 4 && responseFetchKelas.status === 200) {
            if(responseFetchKelas.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    kelas: responseFetchKelas.data.data.dataKelas
                })
            }
        }
    }
    

    kelasOnChange = async (kode) =>{
        kode.persist();
        this.setState({isFetching: true});
        var index = kode.nativeEvent.target.selectedIndex;       
        
        var idKelas = kode.target.value;
        var namaKelas = kode.nativeEvent.target[index].text;

        this.setState({
            idKelas: idKelas,
            namaKelas : namaKelas
        });
        
        this.setState({mapel:[]});
        this.setState({kategori:[]});
        this.setState({soal:[]});

        const resMapel = await accountManagement.get(CONFIG.MIGRASI_V1_MAPEL+idKelas)
        .catch(function(error) {
            console.log('kelas error '+error)
        });

        if(resMapel.request.readyState === 4 && resMapel.status === 200) {
            if(resMapel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    mapel: resMapel.data.data.dataMapel
                })
            }
        }
        this.setState({isFetching: false});
    }

    mapelOnChange = async (kode) =>{
        kode.persist();
        this.setState({isFetching: true});
        var index = kode.nativeEvent.target.selectedIndex;       
        
        var idMapel = kode.target.value;
        var namaMapel = kode.nativeEvent.target[index].text;

        this.setState({
            idMapel: idMapel,
            namaMapel :namaMapel
        })
        this.setState({kategori:[]});
        this.setState({soal:[]});

        const resKateg = await accountManagement.get(CONFIG.MIGRASI_V1_KATEGORI+idMapel)
        .catch(function(error) {
            console.log('kelas error '+error)
        });

        if(resKateg.request.readyState === 4 && resKateg.status === 200) {
            if(resKateg.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    kategori: resKateg.data.data.dataKategori
                })
            }
        }
        this.setState({isFetching: false});
    }

    kategoriOnChange = async (kode) =>{
        kode.persist();
        this.setState({cariSoal: true});
        var index = kode.nativeEvent.target.selectedIndex;       
        
        var idKategori = kode.target.value;
        var namaKategori = kode.nativeEvent.target[index].text;
        
        this.setState({
            idKategori: idKategori,
            namaKategori :namaKategori
        })
        this.setState({soal:[]});

        const resKategBankSoal = await accountManagement.get(CONFIG.MIGRASI_V1_SOALBYKATEGORI+idKategori)
        .catch(function(error) {
            console.log('kelas error '+error)
        });

        if(resKategBankSoal.request.readyState === 4 && resKategBankSoal.status === 200) {
            if(resKategBankSoal.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    soal: resKategBankSoal.data.data.dataSoalKategori
                })
                // window.tinyMCE.get('pertanyaan').setContent(resKategBankSoal.data.data.dataSoalKategori.pertanyaan === null ? "" : resKategBankSoal.data.data.dataSoalKategori.pertanyaan); 
                // console.log(resKategBankSoal.data.data.dataSoalKategori.pertanyaan);
            }
        }
        var namaUH = this.state.namaKelas+"~"+this.state.namaMapel+"~"+this.state.namaKategori;
        this.setState({namaUploadHistori:namaUH});

        this.setState({cariSoal: false});
    }

    inputUHOnChange = async (kode) =>{
        this.setState({namaUploadHistori: kode.target.value})
    }

    prosesMigrasi = async (kode) =>{
        this.setState({isFetching: true});
        
        const resMigrasi = await accountManagement.post(CONFIG.MIGRASI_V1_PROSES_MIGRASI,{  
            ['namaUploadHistori']: this.state.namaUploadHistori,
            ['idKategoriBankSoal']: this.state.idKategori
        }).catch (function(error){
        })

        // if(resMigrasi.request.readyState === 4 && resMigrasi.status === 200) {
        //     if(resMigrasi.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        //         this.setState({
        //             kategori: resMigrasi.data.data
        //         })
        //     }
        // }
        this.setState({isFetching: false});
        alert(resMigrasi.data.data.msg)
    }

    

    render() {
        return (
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar />
                    <Row>
                        <Col sm={4}>
                            <select className="form-control" value={this.state.idKelas===null? "" : this.state.idKelas} onChange={this.kelasOnChange.bind(this)} required>
                                <option value="" selected disabled>~~ Pilih Kelas ~~</option>
                                <DdKelas kelas={this.state.kelas}  />
                            </select>
                        </Col>
                        <Col sm={4}>
                            <select className="form-control" value={this.state.idMapel===null? "" : this.state.idMapel} onChange={this.mapelOnChange.bind(this)} required>
                                <option value="" selected >~~ Pilih Mapel ~~</option>
                                <DdMapel mapel={this.state.mapel}  />
                            </select>
                        </Col>
                        <Col sm={4}>
                            <select className="form-control" value={this.state.idKategori===null? "" : this.state.idKategori} onChange={this.kategoriOnChange.bind(this)} required>
                                <option value="" selected >~~ Pilih Kategori ~~</option>
                                <DdKategori kategori={this.state.kategori}  />
                            </select>
                        </Col>
                    </Row>
                    <br></br>
                    <Row>
                        <Col sm={8}>
                            <input className="form-control" placeholder="Nama Upload Histori" value={this.state.namaUploadHistori} onChange={this.inputUHOnChange.bind(this)}></input>
                        </Col>
                        <Col sm={4}>
                            <button className="btn btn-primary" onClick={this.prosesMigrasi}> <li className="fa fa-car"> G.A.S !!!</li></button>
                        </Col>
                    </Row>
                    <br></br>
                    {this.loading()}
                        <Col>
                            <table className="table">
                                <thead>
                                    <th width='10px'>No</th>
                                    <th>Topik</th>
                                    <th>Pertanyaan</th>
                                    <th>pembahasan</th>
                                </thead>
                                <tbody>
                                    {this.state.soal.map((s, i) => 
                                        <tr key={i}>
                                            <td>{i+1}.</td>
                                            <td>{s.topik}</td>
                                            <td dangerouslySetInnerHTML={{__html: s.pertanyaan}}></td>
                                            <td dangerouslySetInnerHTML={{__html: s.pembahasan_text}}></td>
                                        </tr>
                                    )}                            
                                </tbody>
                            </table>
                        </Col>
                        {/* <ListTableSiswa listSiswa={this.state.SiswaKelasParalel} resetPassword={this.resetPassword}/> */}
                    {this.loading()} 
                </div>
                
            </div>
        )
    }

    loading = () =>{
        if(this.state.cariSoal){
            return(
                <Loader />
            )
        }
    }
}
const mapStateToProps = (state) => {
    return {
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(MigrasiMapel)
